import{useRef as r,useCallback as t}from"react";function e(){var e=r({}),n=r({}),u=t((function(r){return n.current[r]||(n.current[r]=function(t){!e.current[r]&&t?e.current[r]=t:t||delete e.current[r]}),n.current[r]}),[]);return[e,u]}export{e as default};
//# sourceMappingURL=useRefManager.js.map
